module.exports = __webpack_public_path__ + "img/close.7654bcf1.svg";